const memory = new Map();

export const rememberShare = (offerId, base, share) => {
  if (offerId == null) return;
  memory.set(offerId, { ...memory.get(offerId), [base]: share ?? null });
};

export const recallShare = (offerId, base) => memory.get(offerId)?.[base] ?? null;

export const resetPreRemainderShare = () => { memory.clear(); };
